<template>
    <b-modal
        title-tag="h2"
        title="Cancel"
        :lazy="true"
        :visible="isOpen"
        @ok="proceed"
    >
        Are you sure you want to permanently cancel this plan?

        <template v-slot:modal-footer>
            <loader v-if="isLoading" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="close"
                v-if="!isLoading"
            >
                Cancel
            </b-button>

            <b-button v-if="!isLoading" variant="primary" @click="proceed">
                Proceed
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import Axios from "axios";
import Loader from "@/module/commons/loader";

export default {
    components: {
        Loader
    },
    data() {
        return {
            id: null,
            type: null,
            isOpen: false,
            isLoading: false
        };
    },
    methods: {
        open(id) {
            this.isOpen = true;
            this.id = id;
        },
        close() {
            this.isOpen = false;
        },
        async proceed() {
            try {
                this.isLoading = true;

                await Axios.delete(
                    `${process.env.BARRAMUNDI}patient/wellness-plan/${this.id}`
                );

                this.close();
                this._message("Plan cancelled");
                this.$emit("on-success");
            } catch (error) {
                this.isLoading = false;
                this._message("Error: Unable to cancel", "danger");
            }
        }
    }
};
</script>
